import ReportToDatalabCommunicator from "./ReportToDatalabCommunicator";
import { DatalabPostMessageType, EmbeddedDatalab, TembedDatalabParams } from "./types";

export async function embedDatalab({
  iframeSelector,
  iframeUrl,
  data,
  datalabConfig,
  fetchGuestToken,
  clickExplore,
  iframeMounted,
  clickFullscreen,
}: TembedDatalabParams): Promise<EmbeddedDatalab> {
  // 页面初始化时, 创建 通信单例对象
  const instance = ReportToDatalabCommunicator.getInstance(iframeSelector);
  let isRefreshing = false; // 请求锁

  if (instance?.iframe) {
    const { origin, dashboardId } = data || {};
    const datalabConfigKeys = Object.keys(datalabConfig || {});
    const datalabConfigUrlParams = datalabConfigKeys?.length > 0 ? `&${datalabConfigKeys?.map(key => `${key}=${datalabConfig[key]}`)?.join('&')}` : '';
    instance.iframe.src = `${iframeUrl ? iframeUrl : `${origin}/v2/datalab/iframe/report`}?dashboardId=${dashboardId}${datalabConfigUrlParams}`;
  }

  async function refreshGuestToken() {
    // 检查token是否过期
    // if(!instance?.checkTokenExpiry(data?.token, 10)) {
    //   console.log("** token未过期, 不需要刷新token");
    //   return;
    // }
    // 如果token过期了, 则重新获取token, 否则不需要刷新token
    const newGuestToken = await fetchGuestToken?.();
    console.log(data, "refreshGuestToken");
    instance?.updateToken(newGuestToken);
  }

  // 这里使用了一个简单的锁机制，确保在请求未完成时不会重复触发刷新请求
  const refreshGuestTokenWithLock = async () => {
    if (isRefreshing) {
      console.log("请求已发送，请勿重复触发");
      return;
    }
    try {
      isRefreshing = true;
      await refreshGuestToken();
    } finally {
      isRefreshing = false;
    }
  };

  // 当接收到 Iframe发送的 加载完成的消息, 就向iframe发送token等数据
  instance.addMessageHandler(DatalabPostMessageType.ComponentMounted, () => {
    instance?.initData(data);
    // iframe加载完成的回调函数,用于设置loading防止iframe加载过程白屏
    iframeMounted?.();
  });

  // 接收到刷新Token的消息
  instance.addMessageHandler(DatalabPostMessageType.RefreshToken, () => {
    refreshGuestTokenWithLock();
  });

  // 接收到iframe发送的点击探索页面的消息
  instance.addMessageHandler(DatalabPostMessageType.ClickExplore, (payload) => {
    // payload.chartId 探索图表id
    // 点击了探索按钮
    // 承接页面需要 打点 和 关闭侧边栏
    clickExplore?.({ ...payload, type: 'analyse' });
  });

  // 接收到iframe发送的返回报告页面的消息
  instance.addMessageHandler(DatalabPostMessageType.GoBackReport, (payload) => {
    clickExplore?.({ ...payload, type: 'datalab' });
  });

  // iframe发送的点击全屏的消息
  instance.addMessageHandler(DatalabPostMessageType.ClickFullscreen, (payload) => {
    clickFullscreen?.(payload);
  });

  function unmount() {
    ReportToDatalabCommunicator.destroyInstance(iframeSelector);
  }

  return {
    instance,
    unmount,
    refreshGuestToken: refreshGuestTokenWithLock,
  };
}